/**
 * SSE cerceve ayristirici.
 *
 * ## Neden `EventSource` DEGIL
 *
 * EventSource'un cazibesi `Last-Event-ID` ile bedava resume - ama o yalnizca
 * TEK bir EventSource orneginin omru boyunca gecerli. Asil senaryo
 * "kullanici sekmeyi kapatiyor": temiz bir sayfa yuklemesinde gonderilecek
 * `Last-Event-ID` yok, resume zaten KALICI STATE'ten gelmek zorunda. Yani
 * `?after=` mekanizmasi nasilsa yaziliyor ve EventSource'un vitrin ozelligi
 * gereksizlesiyor.
 *
 * Karsiliginda EventSource:
 *   - HTTP status kodu VERMIYOR (401/403/404/429 hepsi opak `onerror`),
 *   - 401'de SONSUZA KADAR retry atiyor,
 *   - backoff kontrolu yok,
 *   - `document.hidden`/offline'da duraklatilamiyor.
 *
 * Yine de sunucu HER cerceveye `id: <seq>` koyuyor, boylece EventSource'a
 * donus her zaman mumkun.
 *
 * ## Bu ayristirici vanilla arayuzden AYNEN tasindi
 *
 * Orada yazilmis ve hatasi ayiklanmis durumda. Yeniden yazmak, cozulmus bir
 * problemi yeniden cozmek olurdu.
 */

export interface SseFrame {
  /** Isimsiz olaylar icin 'message'. */
  event: string
  /** Ham `data:` icerigi (JSON cozulmemis). */
  data: string
  /** `id:` alani - resume icin son gorulen seq. */
  id: number | null
}

/**
 * Akan metinden tam cerceveleri cikarir.
 *
 * Tamponu KENDISI tutmuyor: cagiran yarim kalan kismi saklıyor. Bu bilincli -
 * ayristiricinin durumu olmamasi test etmeyi ve yeniden baglanmada sifirdan
 * baslamayi trivial kiliyor.
 */
export function parseFrames(buffer: string): { frames: SseFrame[]; rest: string } {
  const parts = buffer.split('\n\n')
  // Son parca YARIM olabilir: cagirana geri veriyoruz.
  const rest = parts.pop() ?? ''
  const frames: SseFrame[] = []

  for (const block of parts) {
    const frame = parseBlock(block)
    if (frame) frames.push(frame)
  }
  return { frames, rest }
}

function parseBlock(block: string): SseFrame | null {
  if (!block.trim()) return null
  // Yorum satiri (`: hb`) heartbeat: cerceve DEGIL.
  const lines = block.split('\n')
  let event = 'message'
  let data = ''
  let id: number | null = null
  let sawField = false

  for (const line of lines) {
    if (line.startsWith(':')) continue
    if (line.startsWith('event:')) {
      event = line.slice(6).trim()
      sawField = true
    } else if (line.startsWith('data:')) {
      // SSE'de coklu `data:` satiri newline ile BIRLESTIRILIYOR (spec).
      data += (data ? '\n' : '') + line.slice(5).trimStart()
      sawField = true
    } else if (line.startsWith('id:')) {
      const parsed = Number.parseInt(line.slice(3).trim(), 10)
      id = Number.isFinite(parsed) ? parsed : null
      sawField = true
    }
  }

  return sawField ? { event, data, id } : null
}

/**
 * `data` alanini guvenle cozer.
 *
 * Sunucu her seyi JSON olarak gonderiyor (token metinleri dahil): ham bir
 * satir sonu SSE cercevesini ORTADAN bolerdi. Yine de bozuk veriye karsi
 * korunuyoruz - tek bir bozuk cerceve tum akisi dusurmemeli.
 */
export function decodeData<T = unknown>(data: string, fallback: T): T {
  try {
    return JSON.parse(data) as T
  } catch {
    return fallback
  }
}
